import { render, staticRenderFns } from "./receipt-view.vue?vue&type=template&id=6704e418&scoped=true"
import script from "./receipt-view.vue?vue&type=script&lang=ts"
export * from "./receipt-view.vue?vue&type=script&lang=ts"
import style0 from "./receipt-view.vue?vue&type=style&index=0&id=6704e418&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704e418",
  null
  
)

export default component.exports